import { HttpResponse } from "./HttpResponse";
import { FetchAdapter } from "./../Adapter/FetchAdapter";
export class HttpService {
    /**
     * @param adapter
     */
    constructor(adapter = new FetchAdapter()) {
        this.adapter = adapter;
        /**
         * @type {{}}
         */
        this.requestsInProgress = {};
        /**
         * @type {Array}
         */
        this.requestInterceptors = [];
        /**
         * @type {Array}
         */
        this.responseInterceptors = [];
        /**
         * @type {Array}
         */
        this.responseErrorInterceptors = [];
    }
    /**
     * @param interceptor
     * @returns {Function}
     */
    addRequestInterceptor(interceptor) {
        this.requestInterceptors.push(interceptor);
        return () => {
            const $index = this.requestInterceptors.indexOf(interceptor);
            this.requestInterceptors.splice($index, 1);
        };
    }
    /**
     * @param interceptor
     * @returns {Function}
     */
    addResponseInterceptor(interceptor) {
        this.responseInterceptors.push(interceptor);
        return () => {
            const $index = this.responseInterceptors.indexOf(interceptor);
            this.responseInterceptors.splice($index, 1);
        };
    }
    /**
     * @param interceptor
     * @returns {Function}
     */
    addResponseErrorInterceptor(interceptor) {
        this.responseErrorInterceptors.push(interceptor);
        return () => {
            const $index = this.responseErrorInterceptors.indexOf(interceptor);
            this.responseInterceptors.splice($index, 1);
        };
    }
    /**
     * @param request
     * @returns {Promise<T>}
     */
    send(request) {
        let promise = Promise.resolve(request);
        for (var i = 0; i < this.requestInterceptors.length; i++) {
            promise = promise.then(this.requestInterceptors[i]);
        }
        let hashKeys = [];
        return promise
            .then((newRequest) => {
            const hashKey = JSON.stringify(newRequest);
            if (this.requestsInProgress[hashKey]) {
                return this.requestsInProgress[hashKey];
            }
            hashKeys.push(hashKey);
            if (newRequest instanceof HttpResponse) {
                return newRequest;
            }
            this.requestsInProgress[hashKey] = this.adapter.send(newRequest);
            return this.requestsInProgress[hashKey];
        })
            .then(response => {
            hashKeys.forEach(hashKey => delete this.requestsInProgress[hashKey]);
            return response;
        })
            .then(response => {
            let promise = Promise.resolve(response);
            for (var i = 0; i < this.responseInterceptors.length; i++) {
                promise = promise.then(this.responseInterceptors[i]);
            }
            return promise;
        })
            .catch((error) => {
            hashKeys.forEach(hashKey => delete this.requestsInProgress[hashKey]);
            if (this.responseErrorInterceptors.length === 0) {
                return Promise.reject(error);
            }
            let promise = Promise.resolve(error);
            for (var i = 0; i < this.responseErrorInterceptors.length; i++) {
                promise = promise.then(this.responseErrorInterceptors[i]).catch((error) => { throw error; });
            }
            return promise;
        });
    }
}
